import React from 'react';
import { SectionHeader } from '../../components';

const PopularTopicsSection = () => {
  const topics = [
    {
      icon: 'fas fa-search',
      title: 'SEO & Optimization',
      description: 'Search engine optimization strategies and best practices'
    },
    {
      icon: 'fas fa-bullhorn',
      title: 'Digital Marketing',
      description: 'Modern marketing techniques and campaign strategies'
    },
    {
      icon: 'fas fa-code',
      title: 'Web Development',
      description: 'Latest web development trends and technologies'
    },
    {
      icon: 'fas fa-palette',
      title: 'Design Trends',
      description: 'UI/UX design trends and creative inspiration'
    }
  ];

  return (
    <section className="section-padding bg-light">
      <div className="container">
        <SectionHeader
          title="Popular Topics"
          description="Explore our most-read articles and trending topics"
        />
        <div className="row">
          {topics.map((topic, index) => (
            <div className="col-lg-3 col-md-6 mb-4" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="text-center">
                <i className={`${topic.icon} fa-3x gradient-text mb-3`}></i>
                <h5>{topic.title}</h5>
                <p className="text-muted">{topic.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularTopicsSection;
